<template>
    <v-card>
        <h1 class="text-pagename text-xs-center">Head</h1>
        <headTable/>
    </v-card>
</template>

<script>

import headTable from '@/components/back-office/Rider/Head/HeadTable';
    export default {
        data() {
            return {
            }
        },
        components: {
            headTable
        },
        mounted() {
            const path = [{
                    text: 'Select province',
                    disabled: false,
                    href:  "/weserve_admin_login/select/"
                },
                {
                    text: 'Select service',
                    disabled: false,
                    href: '/weserve_admin_login/control/' + this.$route.params.province
                }, 
                {
                    text: 'Rider',
                    disabled: false,
                    href: '/weserve_admin_login/control/' + this.$route.params.province + '/rider/riderdashboard'
                }, 
                {
                    text: 'Head management',
                    disabled: true,
                }
            ]
            this.$store.commit("backOffice/saveRecentRoute", path);
  }
    }
</script>
